module.exports = __webpack_public_path__ + "static/img/fot2.7316e99f.png";